<script lang="ts">
    import { Col, Row } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Offsetheader, OffsetheaderMessage} from "../../../utils/Constant/Constant";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Offsetheader}  CardBodyprops="grid-showcase">
      <div slot="contentbody">
        <p>{@html OffsetheaderMessage}</p>
        <Row>
          <Col md="4">
            <span>.col-md-4</span>
          </Col>
          <Col md={{ size: 4, offset: 4 }}>
            <span>.col-md-4 .offset-md-4</span>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 3, offset: 3 }}>
            <span>.col-md-3 .offset-md-3</span>
          </Col>
          <Col md={{ size: 3, offset: 3 }}>
            <span>.col-md-3 .offset-md-3</span>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 6, offset: 3 }}>
            <span>.col-md-6 .offset-md-3</span>
          </Col>
        </Row>
        <Row>
          <Col sm="5" md="6">
            <span>.col-sm-5 .col-md-6</span>
          </Col>
          <Col md={{ size: 6}} sm={{ size: 5, offset: 2}} class="offset-md-0">
            <span>.col-sm-5 .offset-sm-2 .col-md-6 .offset-md-0</span>
          </Col>
        </Row>
        <Row>
          <Col sm="6" md="5" lg="6">
            <span>.col-sm-6 .col-md-5 .col-lg-6</span>
          </Col>
          <Col sm="6" md={{ size: 5, offset: 2 }} lg={{ size: 6}} class="offset-lg-0">
            <span>.col-sm-6 .col-md-5 .offset-md-2 .col-lg-6 .offset-lg-0</span>
          </Col>
        </Row>
    </Card>
</Col>